// extracted by mini-css-extract-plugin
export default {"paste":"Z9FTE8VLKdrJJyfWuzJY","common_bganimation":"WvDUiBVLqgWf2yxeo2mo"};